import MoreOrLess from '@xo-union/tk-component-more-or-less';
import classNames from 'classnames';
import { format, parseISO } from 'date-fns';
import React, { type FC, useMemo, memo } from 'react';
import Styles from './styles.scss';

export interface Props {
	vendorName: string | null;
	createdDate?: string | null;
	text?: string | null;
	minimize?: boolean | null;
}

const VendorReply: FC<Props> = memo(
	({ createdDate, text, vendorName, minimize }) => {
		const dateFormatted = useMemo(() => {
			if (!createdDate) {
				return '';
			}
			const date = parseISO(createdDate);

			return format(date, 'MM/dd/yyyy');
		}, [createdDate]);

		if (!text) {
			return null;
		}

		const title = `Response from ${vendorName} on ${dateFormatted}`;

		return (
			<div
				className={Styles.commentWrapper}
				data-testid="vendor-reply-component"
			>
				<div className={Styles.headingWrapper}>{title}</div>
				<MoreOrLess
					className={classNames({
						[Styles.commentBody]: !minimize,
						[Styles.commentBodyMinimize]: minimize,
					})}
					content={text}
					charLimit={minimize ? 90 : 244}
				/>
			</div>
		);
	},
);

export default VendorReply;
